<template>
  <tr class="text-center">
    <td>
      {{ fee.reason?.name }}
    </td>
    <td>
      {{ $formatLocalAmount(fee?.amount) }}
    </td>
    <td> FCFA </td>
  </tr>
</template>

<script setup>
import {defineProps} from "vue";

const props = defineProps({
  fee: Object,
  index: Number,
  currency: String
})

import {$formatLocalAmount} from "@/mixins/Helpers";
import Button from "@/components/Button.vue";

const toggleShowModal = () => {
  $(`#show-file-modal${props.fee.id}`).modal('toggle')
}

</script>

<style scoped>
.bdg {
  display: inline-block;
  padding: .325rem .5rem;
  font-size: .85rem;
  font-weight: 600;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: .325rem;
}

.bdg.bdg-circle{
  border-radius: 50%;
  padding: 0;
  min-width: unset;
  width: 1.75rem;
}

.bdg.bdg-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 1.75rem;
  min-width: 1.75rem;
  padding: 0 .1rem;
  line-height: 0;
}
</style>
